import React from "react";
import { useNavigate } from "react-router-dom";
import mcbLogo from "../images/mcb-logo.png";

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:4040/api";
const API = `${API_BASE}/combined-auth`;

export default function LoginPage() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = React.useState(false);
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [error, setError] = React.useState("");

const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    setError("");

    const res = await fetch(`${API}/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password }),
    });

    const result = await res.json().catch(() => ({}));

    if (!res.ok) {
      throw new Error(result?.error || "Invalid email or password");
    }

    if (result.userType === "customer") {
      localStorage.setItem("customerToken", result.token);
      localStorage.setItem("customer", JSON.stringify(result.customer));
      navigate("/portal");
      return;
    }

    // Staff login — unchanged behaviour
    localStorage.setItem("token", result.token);
    localStorage.setItem("user", JSON.stringify(result.user));
    navigate("/dashboard");

  } catch (err) {
    console.error(err);

    setError(
      err.message || "Invalid email or password"
    );
  }
};

  return (
    <main className="min-h-screen bg-slate-50 px-4 py-10">
      <div className="mx-auto flex min-h-[80vh] w-full max-w-md items-center justify-center">
        <div className="w-full rounded-[28px] border border-slate-200 bg-white p-8 shadow-xl sm:p-10">
          <div className="mb-8 text-center">
            <img
              src={mcbLogo}
              alt="McCallum Bros Ltd"
              className="mx-auto mb-4 h-14 w-auto"
            />
            <p className="mt-2 text-sm text-slate-500">
              Staff &amp; customer portal access
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label htmlFor="email" className="text-sm font-medium text-slate-700">
                Email
              </label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-1 w-full rounded-2xl border border-slate-300 px-4 py-3 focus:border-slate-950 focus:outline-none"
                placeholder="you@mccallumbros.co.nz"
                autoComplete="email"
              />
            </div>

            <div>
              <label htmlFor="password" className="text-sm font-medium text-slate-700">
                Password
              </label>
              <div className="relative mt-1">
                <input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full rounded-2xl border border-slate-300 px-4 py-3 pr-16 focus:border-slate-950 focus:outline-none"
                  placeholder="Enter password"
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword((prev) => !prev)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-sm font-medium text-slate-500 transition hover:text-slate-950"
                >
                  {showPassword ? "Hide" : "Show"}
                </button>
              </div>
            </div>

            {error ? <p className="text-sm text-red-500">{error}</p> : null}

            <button
              type="submit"
              className="w-full rounded-2xl bg-slate-950 py-3 font-semibold text-white transition hover:bg-slate-800"
            >
              Log In
            </button>
          </form>
        </div>
      </div>
    </main>
  );
}